//#region ../../packages/components/button/src/constants.ts
const buttonGroupContextKey = Symbol("buttonGroupContextKey");

//#endregion
export { buttonGroupContextKey };
//# sourceMappingURL=constants.mjs.map